import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { MobileLandingIcon, TargetAdsIcon } from './PlumbingIcons';
export function CuraSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 40
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="py-24 px-4 relative z-10 bg-dark" data-id="element-88">
      {/* Subtle background glow for this section */}
      <div className="absolute inset-0 z-0 pointer-events-none flex justify-center items-center" data-id="element-89">
        <div className="w-full max-w-4xl h-96 bg-emerald/5 rounded-full blur-[100px]" data-id="element-90" />
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-16" data-id="element-92">
          <h2 className="text-4xl md:text-5xl font-black text-gold tracking-tight uppercase" data-id="element-93">
            La Cura
          </h2>
          <div className="w-24 h-1 bg-emerald mx-auto mt-6 rounded-full shadow-neon-green" data-id="element-94" />
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-95">
          {/* Card 1 */}
          <motion.div variants={cardVariants} className="group relative bg-dark-card rounded-2xl p-10 border border-emerald/50 shadow-neon-green transition-all duration-300 hover:shadow-neon-green-lg hover:-translate-y-2 overflow-hidden" data-id="element-96">
            <div className="absolute -right-10 -bottom-10 opacity-5 group-hover:opacity-10 transition-opacity transform group-hover:scale-110 duration-500" data-id="element-97">
              <MobileLandingIcon size={200} className="text-emerald" data-id="element-98" />
            </div>

            <div className="relative z-10" data-id="element-99">
              <div className="w-16 h-16 rounded-full bg-emerald/10 flex items-center justify-center mb-8 border border-emerald/30" data-id="element-100">
                <MobileLandingIcon size={32} className="text-emerald animate-pulse-glow" data-id="element-101" />
              </div>

              <h3 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-102">
                Landing de Respuesta Rápida
              </h3>

              <p className="text-lg text-gray-400 leading-relaxed" data-id="element-103">
                Diseñada para que el cliente haga clic en{' '}
                <span className="text-white font-semibold" data-id="element-104">
                  "Llamar" en menos de 3 segundos
                </span>{' '}
                desde su celular.
              </p>
            </div>
          </motion.div>

          {/* Card 2 */}
          <motion.div variants={cardVariants} className="group relative bg-dark-card rounded-2xl p-10 border border-emerald/50 shadow-neon-green transition-all duration-300 hover:shadow-neon-green-lg hover:-translate-y-2 overflow-hidden" data-id="element-105">
            <div className="absolute -right-10 -bottom-10 opacity-5 group-hover:opacity-10 transition-opacity transform group-hover:scale-110 duration-500" data-id="element-106">
              <TargetAdsIcon size={200} className="text-emerald" data-id="element-107" />
            </div>

            <div className="relative z-10" data-id="element-108">
              <div className="w-16 h-16 rounded-full bg-emerald/10 flex items-center justify-center mb-8 border border-emerald/30" data-id="element-109">
                <TargetAdsIcon size={32} className="text-emerald animate-pulse-glow" data-id="element-110" />
              </div>

              <h3 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-111">
                Google Ads Quirúrgico
              </h3>

              <p className="text-lg text-gray-400 leading-relaxed" data-id="element-112">
                Apareces{' '}
                <span className="text-white font-semibold" data-id="element-113">
                  exactamente cuando el agua está inundando
                </span>{' '}
                la sala de tu cliente. Punto.
              </p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}